// We'll use a getter function that's set by the project-details module
// This avoids circular dependencies while still allowing access to the store
let getCurrentProjectDomainFn: (() => string | null) | null = null;

/**
 * Sets the function to get the current project domain.
 * This should be called by the project-details module to provide access without circular dependencies.
 */
export function setGetCurrentProjectDomainFn(fn: () => string | null) {
  getCurrentProjectDomainFn = fn;
}

/**
 * Gets the cached project domain from currentProjectStore.
 * This is used for proactive region checking before making query API requests.
 *
 * @returns The project domain (e.g., "mixpanel.com", "eu.mixpanel.com", "in.mixpanel.com")
 *          or null if not available. For local dev, domain will be an empty string.
 */
export function getCachedProjectDomain(): string | null {
  try {
    if (!getCurrentProjectDomainFn) {
      // The getter hasn't been set yet - return null to fall back to reactive checking
      return null;
    }

    return getCurrentProjectDomainFn();
  } catch (_error) {
    // If anything fails, return null rather than throwing
    // This ensures the API client can gracefully fall back to reactive region checking
    return null;
  }
}
